<template>
  <div
    v-if="selectedProfileIsLoaded"
    class="ValidationTabs"
  >
    <Tabs
      v-if="tabsNames.length > 1"
      v-model="activeTab"
      class="mt-16 mx-0"
      :tabs="tabsNames"
      centered
    />
    <div class="ValidationTabs_content pa-8">
      <div class="ValidationTabs_sectionStep">
        {{ $t('welcome.step', { stepNumber: 1 }) }}
      </div>
      <PersonTabPerso />
      <div class="ValidationTabs_sectionStep">
        {{ $t('welcome.step', { stepNumber: 2 }) }}
      </div>
      <PersonTabContact />
      <div class="ValidationTabs_sectionStep">
        {{ $t('welcome.step', { stepNumber: 3 }) }}
      </div>
      <PersonTabBank />
      <div class="ValidationTabs_sectionStep">
        {{ $t('welcome.step', { stepNumber: 4 }) }}
      </div>
      <PersonTabDocs />
    </div>
  </div>
</template>

<script>
  import PersonTabPerso from '@/components/RightDrawer/display/PersonTabPerso'
  import PersonTabContact from '@/components/RightDrawer/display/PersonTabContact'
  import PersonTabBank from '@/components/RightDrawer/display/PersonTabBank'
  import PersonTabDocs from '@/components/RightDrawer/display/PersonTabDocs'
  import Tabs from '@/components/ui/common/Tabs/Tabs'
  import CommonMixin from '@/mixins/store/CommonMixin'

  export default {
    components: {
      Tabs,
      PersonTabPerso,
      PersonTabContact,
      PersonTabBank,
      PersonTabDocs,
    },
    mixins: [CommonMixin,],
    data() {
      return {
        activeTab: 0,
        formValid: false,
      }
    },
    computed: {
      tabsIds() {
        const people = this.peopleDetails.map((item) => {
          return item.id
        })
        people.unshift(this.currentUser.id)

        return people
      },
      tabsNames() {
        const people = []
        people.push(this.$t('main.sections.your_profile'))
        this.peopleDetails.forEach((element) => {
          if (element.id) {
            let label = this.$t(`main.roles.${element.person_kind}`)
            label += `: ${element.first_name} ${element.last_name}`
            people.push(label)
          }
        })

        return people
      },
    },
    watch: {
      activeTab() {
        this.setConfigForTab()
      },
      currentConfig() {
        this.setConfigForTab()
      },
    },
    methods: {
      setConfigForTab() {
        if (Object.keys(this.currentConfig).length) {
          this.toggleAppLoader(true)
          this.$store.commit('profile/selectProfile', this.tabsIds[this.activeTab])
          this.$store.commit('common/setConfigFields', this.selectedProfile.person_kind)
          this.toggleAppLoader(false)
        }
      },
    },
  }
</script>

<style scoped lang="scss">
.ValidationTabs {
  &_content {
    max-width: 1060px;
    margin: 1rem auto;
    background: white;
  }
  &_sectionStep {
    color: $color-009ee0;
    text-transform: uppercase;
    font-size: 0.8em;
    font-weight: 600;
    letter-spacing: 0.32px;
    line-height: 20px;
    margin-top: 1rem;
  }
}
</style>
